var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F6EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7765 9.75H14.3876C11.6168 9.75 9.76953 11.5 9.76953 14.125V22.875C9.76953 25.5 11.6168 27.25 14.3876 27.25H21.7765C24.5473 27.25 26.3945 25.5 26.3945 22.875V14.125C26.3945 11.5 24.5473 9.75 21.7765 9.75ZM23.2265 15.42L21.2131 18.4825C21.1577 18.5612 21.0653 18.6225 20.9729 18.6312C20.9545 18.6312 20.936 18.6312 20.9268 18.6312C20.8436 18.6312 20.7605 18.605 20.6958 18.5525C19.2088 17.3013 16.9737 17.3013 15.4867 18.5525C15.4128 18.6138 15.3112 18.6487 15.2096 18.6312C15.108 18.6137 15.0156 18.5612 14.9695 18.4825L12.956 15.42C12.8452 15.2887 12.8729 15.1137 13.0022 15C15.8931 12.5588 20.2618 12.5588 23.1619 15C23.2912 15.1137 23.3189 15.2887 23.2265 15.42Z",
    fill: "#7D6299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDevice);
export default __webpack_public_path__ + "static/media/smart-device.4d5938fbc6947e5ab65c8dc4c4037900.svg";
export { ForwardRef as ReactComponent };